
import { FlavorApi } from "../openapi";
import openApiConfig from "./http_service";

const flavorApi=new FlavorApi(openApiConfig)

export default flavorApi